import script from "./CharacteristicDepartment.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacteristicDepartment.vue?vue&type=script&setup=true&lang=js"

import "./CharacteristicDepartment.vue?vue&type=style&index=0&id=8b3b5c80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b3b5c80"]])

export default __exports__